import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";
import componentStyles from "./candidate-privacy-notice.scss";
import { PRIVACY_NOTICE_URL, PRIVACY_NOTICE_TEXT } from "../../careers-constants.js";
const CandidatePrivacyNotice = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${componentStyles.__hash}` + " " + "candidate-privacy-notice",
        children: [
            /*#__PURE__*/ _jsx(SecondaryButton, {
                color: BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
                buttonText: PRIVACY_NOTICE_TEXT,
                url: PRIVACY_NOTICE_URL,
                isOpenLinkInNewTab: true
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
export default CandidatePrivacyNotice;
